export const SHOP_TYPE = {
  SHOPS: 'shops',
  OTHER: 'other',
};
